import BackendService from './BackendService';

export default class UtilsService {
  static getCounties({
    dealerId,
    zipCode,
  }: {
    dealerId: string;
    zipCode: string;
  }) {
    const params = { dealerId };
    return BackendService.get(`/utils/counties-cities/${zipCode}/`, { params });
  }
}
